var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgEnterFullScreen(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    id: "enterFullScreen_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    className: "enterFullScreen_svg__st0",
    d: "M1.8 1.1h4c.3 0 .5-.2.5-.5S6.1 0 5.8 0H1.6C.7 0 0 .7 0 1.6v4.2c0 .3.2.5.5.5s.5-.2.5-.5v-4l6 5.9c.1.1.2.2.4.2.1 0 .3-.1.4-.2.2-.2.2-.5 0-.7l-6-5.9zM18.4 0h-4.2c-.3 0-.5.2-.5.5s.2.5.5.5h4l-5.9 6c-.2.2-.2.5 0 .7.1.1.2.2.4.2s.3-.1.4-.2L19 1.8v4c0 .3.2.5.5.5s.5-.2.5-.5V1.6c0-.9-.7-1.6-1.6-1.6zM19.5 13.7c-.3 0-.5.2-.5.5v4l-6-5.9c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l5.9 5.9h-4c-.3 0-.5.2-.5.5s.2.5.5.5h4.2c.9 0 1.6-.7 1.6-1.6v-4.2c0-.2-.2-.4-.5-.4zM7 12.3l-5.9 5.9v-4c0-.3-.2-.5-.5-.5s-.6.2-.6.5v4.2c0 .9.7 1.6 1.6 1.6h4.2c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-4l6-6c.2-.2.2-.5 0-.7s-.6-.2-.8 0z"
  })));
}
export default SvgEnterFullScreen;